import { h as head, e as escape_html, b as attr, p as pop, a as push } from "../../../../chunks/index2.js";
import "@sveltejs/kit/internal";
import "../../../../chunks/exports.js";
import "../../../../chunks/utils.js";
import "../../../../chunks/state.svelte.js";
import { g as getToastState } from "../../../../chunks/Toast.svelte.js";
function _page($$payload, $$props) {
  push();
  let { data } = $$props;
  let convenienceFee = data.convenienceFee || null;
  getToastState();
  head($$payload, ($$payload2) => {
    $$payload2.title = `<title>Convenience Fee</title>`;
  });
  $$payload.out.push(`<div class="container mx-auto p-6"><div class="mb-6"><div class="mb-4 flex items-center justify-between"><h1 class="text-3xl font-bold">Convenience Fee Management</h1> `);
  if (convenienceFee) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<button class="bg-primary hover:bg-primary/90 rounded-lg px-4 py-2 text-white">${escape_html("Edit Fee")}</button>`);
  } else {
    $$payload.out.push("<!--[!-->");
    $$payload.out.push(`<button class="bg-primary hover:bg-primary/90 rounded-lg px-4 py-2 text-white">${escape_html("Add Fee")}</button>`);
  }
  $$payload.out.push(`<!--]--></div> `);
  {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--> <div class="overflow-x-auto rounded-md border border-gray-200 bg-white"><table class="min-w-full divide-y divide-gray-200"><thead class="bg-gray-50"><tr><th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Amount</th><th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Actions</th></tr></thead><tbody class="divide-y divide-gray-200">`);
  if (!convenienceFee) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<tr><td class="px-6 py-4 text-center text-sm text-gray-500" colspan="2">No convenience fee set</td></tr>`);
  } else {
    $$payload.out.push("<!--[!-->");
    $$payload.out.push(`<tr class="hover:bg-gray-50"><td class="px-6 py-4"><div class="font-bold text-gray-900">KES ${escape_html(convenienceFee.amount.toFixed(2))}</div></td><td class="px-6 py-4"><div class="flex space-x-5"><button class="text-primary hover:text-primary/80">Edit</button> <form method="POST" action="?/delete_fee"><input type="hidden" name="id"${attr("value", convenienceFee.id)}/> <button type="submit" class="text-red-600 hover:text-red-800">Delete</button></form></div></td></tr>`);
  }
  $$payload.out.push(`<!--]--></tbody></table></div></div></div>`);
  pop();
}
export {
  _page as default
};
